import { heroValuePartner } from '../../../../constants/partnerPageConst';
import { handleTrack } from '../../../../utils/tracker';
import { If } from '../../../Atoms/Conditionals';
import { KnowMore } from '../../../Common/buttons/know-more';
import { addQueryParamToURL } from '../../../Utils/CommonUtils';
import {
  getCheckoutUrl,
  getIsITRPlan,
  getPlanPageUrl,
} from '../../utils/utils';

interface IPlanFooter {
  listingId: string;
  planId: string;
  productServiceType: string;
  coupon?: string;
  showKnowMore?: boolean;
  trackLabel?: string;
}

export const PlanFooter: React.FC<IPlanFooter> = ({
  listingId,
  planId,
  productServiceType,
  coupon,
  showKnowMore = true,
  trackLabel = '',
}): JSX.Element => {
  const isItrPlan = getIsITRPlan(productServiceType);
  return (
    <div className="absolute bottom-0 left-0 w-full px-6 mt-2">
      <a
        href={addQueryParamToURL(
          isItrPlan ? heroValuePartner.btnLink : getCheckoutUrl(listingId),
          'coupon',
          coupon
        )}
        className="text-white w-full px-6 py-3  bg-blue-350 hover:bg-blue-450 font-bold rounded-md block text-center mb-2 sm:ml-0 sm:my-2"
        onClick={(e) =>
          handleTrack({ label: `${trackLabel}plan-card`, obj: e.target })
        }
        data-testid="buy_now_button"
      >
        {isItrPlan ? 'File Now' : 'Buy Now'}
      </a>

      <div className="justify-center flex pb-3">
        <If condition={showKnowMore}>
          <KnowMore
            href={isItrPlan ? heroValuePartner.btnLink : getPlanPageUrl(planId)}
            funnelMetricLabel={`${trackLabel}plan-card`}
            className="py-2 w-full text-center"
            arrow={false}
            hoverEffect={true}
          />
        </If>
      </div>
    </div>
  );
};
